import { Tooltip as MuiTooltip } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./tooltip-v2.styles.module.scss";

const propTypes = {
  children: PropTypes.any,
  deactivate: PropTypes.bool,
  rootClassName: PropTypes.string,
  title: PropTypes.any,
  isMasked: PropTypes.bool,
};

/**
 * @deprecated DO NOT USE, DO NOT UPDATE
 */
const TooltipV2 = ({ children, deactivate = false, rootClassName = "", title, isMasked = false, ...props }) => {
  return (
    <MuiTooltip
      arrow={true}
      classes={{
        popper: rootClassName,
        tooltip: styles.tooltip,
        tooltipArrow: styles.tooltipArrow,
        arrow: styles.arrow,
      }}
      disableFocusListener={deactivate}
      disableHoverListener={deactivate}
      disableTouchListener={deactivate}
      title={<span data-amp-mask={isMasked ? "" : undefined} className={styles.text}>{title}</span>}
      {...props}
      enterDelay={600}
      enterNextDelay={600}
      TransitionProps={{ timeout: { appear: 300, enter: 300, exit: 300 } }}
    >
      {children}
    </MuiTooltip>
  );
};

TooltipV2.propTypes = propTypes;
export default TooltipV2;
